import { licenseDisplayName, type LicenseRow } from '../../types/onboarding'

/** Unique business entity names from the Business Licenses step. */
export function businessEntityNamesFromLicenses(licenses: LicenseRow[]): string[] {
  const names = licenses
    .filter((l) => l.entity === 'BusinessEntity')
    .map((l) => licenseDisplayName(l).trim())
    .filter((name) => name.length > 0)
  return Array.from(new Set(names))
}

export function companyNameOptions(
  licenses: LicenseRow[],
  currentValues: (string | undefined)[],
): string[] {
  const fromEntities = businessEntityNamesFromLicenses(licenses)
  const extras = currentValues
    .map((v) => v?.trim())
    .filter((v): v is string => Boolean(v))
  return Array.from(new Set(fromEntities.concat(extras)))
}

/** Keep or reset login-row client selection when options change (e.g. after Business Licenses edits). */
export function mergeLoginClientCompanyName(
  existing: string | undefined | null,
  licenses: LicenseRow[],
  otherLoginClientValues: (string | undefined)[],
): string {
  const opts = companyNameOptions(licenses, [
    ...otherLoginClientValues,
    ...(existing ? [existing] : []),
  ])
  if (opts.length === 0) return (existing ?? '').trim()
  if (opts.length === 1) return opts[0]!
  const ex = (existing ?? '').trim()
  if (ex && opts.includes(ex)) return ex
  return ''
}
